import RedEnvelope from "@/views/editor/service/red_envelope/red_envelope/index";
import {INewBusiness} from "@/views/editor/service/business";

export default {'red_envelope': RedEnvelope} as { [key: string]: INewBusiness}